export const MENU_ICON_DOTS = [4, 12, 20];
export const MENU_ICON_DOT_RADIUS = 2.6;
